import { 
    Button, Dialog, DialogActions, DialogContent, DialogTitle,
    FormControl, Grid, InputLabel, MenuItem, Select, TextField,
    Box, Typography, IconButton, Switch, FormControlLabel
} from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { actualizarUsuario } from '../../../services/apis';
import { AlertError } from '../../../utils/componentes-utiles/AlertError';
import { ContasenaOculta } from '../../../utils/componentes-utiles/ContasenaOculta';

// Hook para detectar clics fuera del componente
const useClickOutside = (ref, callback) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, callback]);
};

export const EditarUsuario = ({ 
    open, 
    setOpen, 
    cargarUsuarios, 
    roles, 
    departamentos, 
    usuarioData 
}) => {
    const handleClose = () => {
        setOpen(false);
    };
    
    const [errorAlert, setErrorAlert] = useState(false);
    const [errorPassAlert, setErrorPassAlert] = useState(false);
    const [errorRespuesta, setErrorRespuesta] = useState(false);
    const [mensajeError, setMensajeError] = useState("");
    const [contrasena, setContrasena] = useState("");
    const [confirmarContrasena, setConfirmarContrasena] = useState("");
    const [cambiarContrasena, setCambiarContrasena] = useState(false);
    const [cargando, setCargando] = useState(false);
    const [showColorPicker, setShowColorPicker] = useState(false);
    
    // Estados para nuevos campos
    const [telefono, setTelefono] = useState("");
    const [nif, setNif] = useState("");
    const [apellidos, setApellidos] = useState("");
    
    const [usuario, setUsuario] = useState({
        'id': '',
        'nombre': '',
        'apellidos': '',
        'mail': '',
        'id_rol': '',
        'id_departamento': '',
        'color': '#1976d2',
        'telefono': '',
        'nif': ''
    });

    const [color, setColor] = useState('#1976d2');
    const colorPickerRef = useRef(null);

    // Configurar el hook para cerrar al hacer clic fuera
    useClickOutside(colorPickerRef, () => {
        if (showColorPicker) {
            setShowColorPicker(false);
        }
    });

    // Filtrar roles y departamentos (excluir Totem)
    const rolesFiltrados = Array.isArray(roles) ? roles.filter(rol => rol.id !== 930 && rol.id !== 931) : [];
    const departamentosFiltrados = Array.isArray(departamentos) ? departamentos.filter(depto => depto.id !== 30) : [];

    // Inicializar estados cuando se abre el modal
    useEffect(() => {
        if (usuarioData && open) {
            console.log("Cargando usuario para editar:", usuarioData);
            
            setUsuario({
                'id': usuarioData.id || '',
                'nombre': usuarioData.nombre || '',
                'apellidos': usuarioData.apellidos || '',
                'mail': usuarioData.mail || '',
                'id_rol': usuarioData.rol || usuarioData.id_rol || '',
                'id_departamento': usuarioData.departamento || usuarioData.id_departamento || '',
                'color': usuarioData.color || '#1976d2',
                'telefono': usuarioData.telefono || '',
                'nif': usuarioData.nif || ''
            });
            
            setColor(usuarioData.color || '#1976d2');
            setTelefono(usuarioData.telefono || '');
            setNif(usuarioData.nif || '');
            setApellidos(usuarioData.apellidos || '');
            setContrasena("");
            setConfirmarContrasena("");
            setCambiarContrasena(false);
            setErrorAlert(false);
            setErrorPassAlert(false);
            setErrorRespuesta(false);
            setMensajeError("");
            setShowColorPicker(false);
            setCargando(false);
        }
    }, [usuarioData, open]);

    // Sincronizar estados con el objeto usuario (CON DEPENDENCIAS CORRECTAS)
    useEffect(() => {
        if (usuarioData) {
            setUsuario(prev => ({ 
                ...prev, 
                color: color,
                telefono: telefono,
                nif: nif,
                apellidos: apellidos
            }));
        }
    }, [color, telefono, nif, apellidos, usuarioData]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUsuario(prev => ({ ...prev, [name]: value }));
        setErrorAlert(false);
    };

    const handleColorChange = (event) => {
        setColor(event.target.value);
    };

    const toggleColorPicker = () => {
        setShowColorPicker(!showColorPicker);
    };

    const toggleCambiarContrasena = () => {
        setCambiarContrasena(!cambiarContrasena);
        if (!cambiarContrasena) {
            setContrasena("");
            setConfirmarContrasena("");
        }
    };

    // Función para formatear teléfono
    const handleTelefonoChange = (event) => {
        let value = event.target.value.replace(/\D/g, '');
        
        if (value.length > 6) {
            value = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6, 9);
        } else if (value.length > 3) {
            value = value.substring(0, 3) + ' ' + value.substring(3, 6);
        }
        
        setTelefono(value);
        setErrorAlert(false);
    };

    // NIF sin restricciones
    const handleNifChange = (event) => {
        let value = event.target.value.toUpperCase();
        setNif(value);
        setErrorAlert(false);
    };

    // Apellidos
    const handleApellidosChange = (event) => {
        setApellidos(event.target.value);
        setErrorAlert(false);
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        
      
        
        setErrorAlert(false);
        setErrorPassAlert(false);
        setErrorRespuesta(false);
        setCargando(true);
        
        // Validar contraseñas si se están cambiando
        if (cambiarContrasena && contrasena !== confirmarContrasena) {
            setMensajeError("Las contraseñas no coinciden");
            setErrorPassAlert(true);
            setCargando(false);
            return;
        }
        
        // Validar campos obligatorios
        if (!usuario.nombre || !usuario.mail || !usuario.id_rol) {
            setMensajeError("Nombre, email y rol son obligatorios");
            setErrorAlert(true);
            setCargando(false);
            return;
        }
        
        // Validar formato de email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(usuario.mail)) {
            setMensajeError("Formato de email inválido");
            setErrorAlert(true);
            setCargando(false);
            return;
        }
        
        // Preparar datos para envío
        const usuarioEnvio = {
            id: usuario.id,
            nombre: usuario.nombre,
            apellidos: usuario.apellidos,
            mail: usuario.mail,
            id_rol: usuario.id_rol,
            id_departamento: usuario.id_departamento || null,
            color: color,
            telefono: telefono ? telefono.replace(/\s/g, '') : '',
            nif: nif
        };
        
        // Solo añadir contraseña si se quiere cambiar
        if (cambiarContrasena && contrasena) {
            usuarioEnvio.contrasena = contrasena;
        }
        
        console.log("Datos a enviar para actualizar:", usuarioEnvio);
        
        // CORRECCIÓN: Usar un nombre diferente para la función local
        await enviarActualizacion(usuarioEnvio);
    };

    // CORRECCIÓN: Cambiar el nombre de la función local
    const enviarActualizacion = async (usuarioEnvio) => {
        try {
            console.log("Enviando actualización...");
            const response = await actualizarUsuario(usuarioEnvio);
            
            console.log("Respuesta del servidor:", response);
            
            if (response && response.success == true) {
                console.log("Usuario actualizado exitosamente");
                if (cargarUsuarios) {
                    cargarUsuarios();
                }
                handleClose();
            } else {
                const errorMsg = response?.error || response?.message || "Error desconocido al actualizar el usuario";
                console.error("Error del servidor:", errorMsg);
                setMensajeError(errorMsg);
                setErrorRespuesta(true);
            }
        } catch (error) {
            console.error("Error de red:", error);
            setMensajeError("Error de conexión con el servidor");
            setErrorRespuesta(true);
        } finally {
            setCargando(false);
        }
    };

    // Verificar si hay cambios para deshabilitar el botón
    const hayCambios = () => {
        if (!usuarioData) return false;
        
        const cambios = 
            usuario.nombre !== usuarioData.nombre ||
            usuario.apellidos !== usuarioData.apellidos ||
            usuario.mail !== usuarioData.mail ||
            usuario.id_rol !== (usuarioData.rol || usuarioData.id_rol) ||
            usuario.id_departamento !== (usuarioData.departamento || usuarioData.id_departamento) ||
            color !== usuarioData.color ||
            usuario.telefono !== usuarioData.telefono ||
            usuario.nif !== usuarioData.nif ||
            (cambiarContrasena && contrasena);
        
        console.log("¿Hay cambios?", cambios);
        return cambios;
    };

    if (!usuarioData) return null;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            fullWidth
            maxWidth="sm"
        >
            <Grid container direction="row" alignItems="center" justifyContent="space-between">
                <DialogTitle id="form-dialog-title">
                    Editar Usuario: {usuarioData.nombre}
                </DialogTitle>
                <div style={{ paddingRight: '24px' }}>
                    <CancelIcon 
                        onClick={handleClose} 
                        style={{ cursor: 'pointer' }} 
                    />
                </div>
            </Grid>
            
            <DialogContent>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                        
                        {/* Icono de usuario con selector de color */}
                        <Grid item xs={12} sx={{ textAlign: 'center', position: 'relative' }}>
                            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                                <IconButton 
                                    onClick={toggleColorPicker}
                                    sx={{ 
                                        p: 0,
                                        position: 'relative',
                                        transition: 'transform 0.2s',
                                        '&:hover': {
                                            transform: 'scale(1.05)'
                                        }
                                    }}
                                >
                                    <AccountCircleIcon 
                                        sx={{ 
                                            fontSize: 100, 
                                            color: color,
                                            transition: 'color 0.3s ease',
                                            cursor: 'pointer'
                                        }} 
                                    />
                                </IconButton>
                                <Typography variant="caption" sx={{ display: 'block', mt: 1 }}>
                                    Haz click para cambiar el color
                                </Typography>
                                
                                {showColorPicker && (
                                    <Box 
                                        ref={colorPickerRef}
                                        sx={{ 
                                            position: 'absolute',
                                            top: '100%',
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            mt: 2,
                                            p: 2,
                                            bgcolor: 'background.paper',
                                            borderRadius: 2,
                                            boxShadow: 3,
                                            zIndex: 1000,
                                            textAlign: 'center'
                                        }}
                                    >
                                        <Typography variant="subtitle2" sx={{ mb: 2 }}>
                                            Selecciona un color
                                        </Typography>
                                        
                                        <input
                                            type="color"
                                            value={color}
                                            onChange={handleColorChange}
                                            style={{
                                                width: '80px',
                                                height: '80px',
                                                borderRadius: '20%',
                                                border: '3px solid #e0e0e0',
                                                cursor: 'pointer',
                                                display: 'block',
                                                margin: '0 auto'
                                            }}
                                        />                
                                    </Box>
                                )}
                            </Box>
                        </Grid>

                        {/* Nombre y Apellidos */}
                        <Grid item xs={12} container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Nombre *"
                                    variant="outlined"
                                    fullWidth
                                    name="nombre"
                                    value={usuario.nombre}
                                    onChange={handleChange}
                                    error={errorAlert && !usuario.nombre}
                                    disabled={cargando}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Apellidos"
                                    variant="outlined"
                                    fullWidth
                                    value={apellidos}
                                    onChange={handleApellidosChange}
                                    disabled={cargando}
                                />
                            </Grid>
                        </Grid>

                        {/* Email */}
                        <Grid item xs={12}>
                            <TextField
                                label="Email *"
                                variant="outlined"
                                fullWidth
                                type="email"
                                name="mail"
                                value={usuario.mail}
                                onChange={handleChange}
                                error={errorAlert && !usuario.mail}
                                disabled={cargando}
                            />
                        </Grid>

                        {/* Teléfono y NIF */}
                        <Grid item xs={12} container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Teléfono"
                                    variant="outlined"
                                    fullWidth
                                    value={telefono}
                                    onChange={handleTelefonoChange}
                                    placeholder="Ej: 612 345 678"
                                    disabled={cargando}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="NIF/NIE"
                                    variant="outlined"
                                    fullWidth
                                    value={nif}
                                    onChange={handleNifChange}
                                    placeholder="Introduce el NIF/NIE"
                                    inputProps={{
                                        style: { textTransform: 'uppercase' }
                                    }}
                                    disabled={cargando}
                                />
                            </Grid>
                        </Grid>

                        {/* Opción para cambiar contraseña */}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={cambiarContrasena}
                                        onChange={toggleCambiarContrasena}
                                        color="primary"
                                        disabled={cargando}
                                    />
                                }
                                label="Cambiar contraseña"
                            />
                            
                            {cambiarContrasena && (
                                <Grid container spacing={2} sx={{ mt: 1 }}>
                                    <Grid item xs={12} sm={6}>
                                        <ContasenaOculta
                                            contrasena={contrasena}
                                            setContrasena={setContrasena}
                                            label="Nueva Contraseña"
                                            error={errorPassAlert}
                                            disabled={cargando}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <ContasenaOculta
                                            contrasena={confirmarContrasena}
                                            setContrasena={setConfirmarContrasena}
                                            label="Confirmar Contraseña"
                                            error={errorPassAlert}
                                            disabled={cargando}
                                        />
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>

                        {/* Rol y Departamento */}
                        <Grid item xs={12} container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel id="select-rol-label">Rol *</InputLabel>
                                    <Select
                                        value={usuario.id_rol}
                                        name="id_rol"
                                        onChange={handleChange}
                                        label="Rol *"
                                        disabled={cargando}
                                    >
                                        {rolesFiltrados.map((rol) => (
                                            <MenuItem key={rol.id} value={rol.id}>
                                                {rol.nombre}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel id="select-departamento-label">Departamento</InputLabel>
                                    <Select
                                        value={usuario.id_departamento}
                                        name="id_departamento"
                                        onChange={handleChange}
                                        label="Departamento"
                                        disabled={cargando}
                                    >
                                        <MenuItem value="">
                                            <em>Sin departamento</em>
                                        </MenuItem>
                                        {departamentosFiltrados.map((departamento) => (
                                            <MenuItem key={departamento.id} value={departamento.id}>
                                                {departamento.nombre}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button 
                    onClick={handleClose} 
                    color="primary" 
                    variant="outlined"
                    disabled={cargando}
                >
                    Cancelar
                </Button>
                <Button 
                    onClick={handleSubmit} 
                    color="primary" 
                    variant="contained"
                    disabled={cargando || !usuario.nombre || !usuario.mail || !usuario.id_rol || !hayCambios()}
                >
                    {cargando ? 'Guardando...' : 'Guardar Cambios'}
                </Button>
            </DialogActions>

            {/* Alertas de Error */}
            {errorAlert && (
                <AlertError 
                    open={errorAlert} 
                    setOpen={setErrorAlert} 
                    titulo="Error" 
                    mensaje={mensajeError || "Falta rellenar algún campo obligatorio"} 
                />
            )}
            
            {errorPassAlert && (
                <AlertError 
                    open={errorPassAlert} 
                    setOpen={setErrorPassAlert} 
                    titulo="Error" 
                    mensaje={mensajeError || "Las contraseñas no coinciden"} 
                />
            )}
            
            {errorRespuesta && (
                <AlertError 
                    open={errorRespuesta} 
                    setOpen={setErrorRespuesta} 
                    titulo="Error" 
                    mensaje={mensajeError || "Error al actualizar el usuario"} 
                />
            )}
        </Dialog>
    );
};